import { lazy } from "react";
// const Friends = lazy(() => import("../pages/Friends"));
const Home = lazy(() => import("../pages/_archive/Home"));
// const Play = lazy(() => import("../pages/Play"));
const Profile = lazy(() => import("../pages/Profile"));
// const Quests = lazy(() => import("../pages/Quests"));
const Landing = lazy(() => import("../pages/_archive/Landing"));
const QRcode = lazy(() => import("../pages/_archive/QRcode"));
const QRinvite = lazy(() => import("../pages/invites/QRinvite"));
const Newsfeed = lazy(() => import("../pages/Newsfeed"));
const Compete = lazy(() => import("../pages/_archive/Compete"));
const Treasure = lazy(() => import("../pages/_archive/Treasure"));
// const SignIn = lazy(() => import("../pages/Authentication/SignIn"));
const SignUp = lazy(() => import("../pages/Authentication/SignUp"));
const TreasurePage = lazy(() => import("../pages/_archive/TreasurePage"));
const SecretSalute = lazy(() => import("../pages/SecretSalute"));
const Party = lazy(() => import("../pages/_archive/Party"));
const Signup = lazy(() => import("../pages/Signup"));
const QRValidate = lazy(() => import("../pages/invites/QRValidate"));
const PlayQuest = lazy(() => import("../components/quest/PlayQuest"));
const PartyBuilder = lazy(() => import("../pages/PartyBuilder"));
const LeaderBoard = lazy(() => import("../pages/Leaderboard"));
const ChatDemo = lazy(() => import("../pages/_archive/ChatDemo"));
const CreatureFloaterPage = lazy(
	() => import("../pages/_archive/CreatureFloaterPage")
);
const PrizeBoxDemo = lazy(() => import("../pages/_archive/PrizeBoxDemo"));
const LightBallDemo = lazy(() => import("../pages/_archive/LightBallDemo"));
const LightMeterExample = lazy(
	() => import("../components/_archive/LightMeterExample")
);
const GameMaster = lazy(() => import("../pages/GameMaster"));
const EnhancedUserRoleDisplay = lazy(
	() => import("../components/_archive/EnhancedUserRoleDisplay")
);
const PartyManager = lazy(() => import("../pages/PartyManager"));
const RingleaderDashboard = lazy(() => import("../pages/RingleaderDashboard"));
const AcceptInvite = lazy(() => import("../pages/invites/AcceptInvite"));
const QRValidateTest = lazy(() => import("../tests/pages/QRValidateTest"));
const AcceptInviteTest = lazy(() => import("../tests/pages/AcceptInviteTest"));
const JudgeOnboarding = lazy(
	() => import("../components/gamemaster/JudgeOnboarding")
);
const ComplimentPage = lazy(() => import("../pages/_archive/Compliments"));
const QuestTutorialPage = lazy(() => import("../pages/QuestTutorialPage"));
const ChooseQuest = lazy(() => import("../components/quest/ChooseQuest"));
const StarReceipt = lazy(
	() => import("../pages/Salutes/starsalutes/StarReceipt")
);
const StarSalute = lazy(() => import("../components/starsalutes/StarSalute"));
const StarSaluteThumbnail = lazy(
	() => import("../pages/Salutes/starsalutes/StarSaluteThumbnail")
);
const SaluteSelect = lazy(() => import("../pages/Salutes/SaluteSelect"));
const SecretSaluteRedirect = lazy(
	() => import("../pages/Salutes/secretsalutes/SecretSaluteRedirect")
);
const SecretSaluteView = lazy(
	() => import("../pages/_archive/SecretSaluteView")
);
const Guess = lazy(() => import("../pages/Salutes/secretsalutes/Guess"));
const UserDashboard = lazy(() => import("../pages/_archive/UserDashboard"));
const Start = lazy(() => import("../pages/Story/Start"));
const StartSelect = lazy(() => import("../pages/Story/StartSelect"));
const Kidnap = lazy(() => import("../pages/Story/Kidnap"));
const EgyptStory = lazy(() => import("../pages/Story/EgyptStory"));
const StoryPathEditorPage = lazy(
	() => import("../pages/Story/StoryPathEditorPage")
);
const SpaceIntercept = lazy(() => import("../pages/_archive/StoryLandingB"));
// const SpaceIntercept = lazy(() => import("../pages/_archive/StoryLandingB"));
const Starfield = lazy(() => import("../pages/StoryLanding"));
const NewSignup = lazy(() => import("../components/auth/NewSignUp"));
const InstallApp = lazy(() => import("../pages/_archive/InstallApp"));
const VideoForwardTutorial = lazy(
	() => import("../tests/pages/VideoForwardTutorial")
);
const TestGlowComplete = lazy(() => import("../tests/pages/TestGlowComplete"));
const TransparentLoopingVideoExample = lazy(
	() => import("../pages/_archive/TransparentLoopingVideoExample")
);
const TransparentLoopingVideoWhiteMaskExample = lazy(
	() => import("../pages/_archive/TransparentLoopingVideoWhiteMaskExample")
);
const SpriteSheetLoaderTester = lazy(
	() => import("../tests/creature/SpriteSheetLoaderTester")
);
const SpriteSheetAnimationDemonstrator = lazy(
	() => import("../tests/creature/SpriteSheetAnimationDemonstrator")
);
const AnimatedEnvelopePage = lazy(
	() => import("../tests/pages/AnimatedEnvelopePage")
);
const LetterPathEditor = lazy(
	() => import("../pages/_archive/LetterPathEditor")
);
const StarSaluteStillImageTest = lazy(
	() => import("../tests/pages/StarSaluteStillImageTest")
);

// Mock Adventures - Mockup Only
const MyAdventures = lazy(() => import("../pages/adventures/MyAdventures"));
const AdventureCreate = lazy(
	() => import("../pages/adventures/AdventureCreate")
);
const RoleAdventure = lazy(() => import("../pages/adventures/RoleAdventure"));
const RoleSelector = lazy(() => import("../pages/adventures/RoleSelector"));
const SoloAdventure = lazy(() => import("../pages/adventures/SoloAdventure"));
const TestQRScanner = lazy(() => import("../tests/pages/TestQRScanner"));
const QRGeneratorPage = lazy(() => import("../tests/pages/QRGeneratorPage"));
const QrChallengePage = lazy(
	() => import("../pages/qrchallenge/QrChallengePage")
);
const QrChallengeRewardPage = lazy(
	() => import("../pages/qrchallenge/QrChallengeRewardPage")
);
const ScanLanding = lazy(() => import("../pages/invites/ScanLanding"));
const AdventureGmControls = lazy(
	() => import("../pages/adventures/AdventureGmControls")
);
const GmVerifyStep = lazy(() => import("../pages/adventures/GmVerifyStep"));
const AdventureTeamProgress = lazy(
	() => import("../pages/adventures/AdventureTeamProgress")
);
const AdventureSubmissionReveal = lazy(
	() => import("../pages/adventures/AdventureSubmissionReveal")
);
const QRPuzzlePrint = lazy(() => import("../pages/QRPuzzlePrint"));
const IcebreakerSurveyPage = lazy(
	() => import("../pages/adventures/IcebreakerSurveyPage")
);
const SurveyPage = lazy(() => import("../pages/survey/SurveyPage"));
const SurveyResponsesPage = lazy(
	() => import("../pages/survey/SurveyResponsesPage")
);
const EditMemberMilestones = lazy(
	() => import("../pages/gamemaster/EditMemberMilestones")
);
const EditSurveyPage = lazy(() => import("../pages/adventures/EditSurveyPage"));
const VideoSubtitleStudio = lazy(() => import("../pages/VideoSubtitleStudio"));

const coreRoutes = [
	{ path: "/", title: "Home", component: Newsfeed },
	// { path: "/home", title: "Home", component: Home },
	{ path: "/profile", title: "Profile", component: Profile },
	{ path: "/landing", title: "Landing", component: Landing },
	{ path: "/qrcode", title: "QRcode", component: QRcode },
	{ path: "/newsfeed", title: "Newsfeed", component: Newsfeed },
	{ path: "/compete", title: "Compete", component: Compete },
	{ path: "/treasure", title: "Treasure", component: Treasure },
	{ path: "/treasure/:id", title: "Treasure", component: TreasurePage },
	// { path: "/signin", title: "Signin", component: SignIn },
	{ path: "/register", title: "Register", component: SignUp },
	{ path: "/playersignup", title: "Sign Up", component: NewSignup },
	{ path: "/install", title: "Install App", component: InstallApp },
	{ path: "/compliment", title: "Compliment", component: ComplimentPage },
	{
		path: "/secret-salute",
		title: "Secret Salutes",
		component: SecretSalute,
	},
	{
		path: "/secret-salute-redirect",
		title: "Secret Salutes Redirect",
		component: SecretSaluteRedirect,
	},
	{
		path: "/salute-select",
		title: "Salute Select",
		component: SaluteSelect,
	},
	{
		path: "/starsalute",
		title: "Star Salute",
		component: StarSalute,
	},
	{ path: "/party/:id", title: "Party", component: Party },
	{ path: "/signup", title: "Signup", component: Signup },
	{ path: "/invite", title: "QR Invite", component: QRinvite },
	{ path: "/QRvalidate", title: "QR Invite", component: QRValidate },
	{
		path: "/scan",
		title: "Scan Landing",
		component: ScanLanding,
	},
	{
		path: "/QRvalidate/:inviteID",
		title: "QR Invite Test",
		component: QRValidateTest,
	},
	{ path: "/playquest", title: "Quests", component: PlayQuest },
	{ path: "/partybuilder", title: "Quests", component: PartyBuilder },
	{ path: "/leaderboard", title: "LeaderBoard", component: LeaderBoard },
	{
		path: "/newsfeed/:postType/:id",
		title: "Post",
		component: Newsfeed,
		props: { showPost: true },
	},
	// Fallback for old URLs without post type (will try to detect automatically)
	{
		path: "/newsfeed/:id",
		title: "Post",
		component: Newsfeed,
		props: { showPost: true },
	},
	{ path: "/chat-demo", title: "Chat Demo", component: ChatDemo },
	{
		path: "/beamkins",
		title: "Your Beamkins",
		component: CreatureFloaterPage,
	},
	{ path: "/prize-box-demo", title: "Prize Box Demo", component: PrizeBoxDemo },
	{
		path: "/lightball-demo",
		title: "LightBall Demo",
		component: LightBallDemo,
	},
	{
		path: "/lightmeter-example",
		title: "LightMeter Example",
		component: LightMeterExample,
	},
	{ path: "/gamemaster", title: "GameMaster", component: GameMaster },
	{ path: "/judging", title: "Judging", component: GameMaster },
	{
		path: "/quest-tutorial",
		title: "Quest Tutorial",
		component: QuestTutorialPage,
	},
	// Deprecated: quest selection now handled via adventure queue on /adventures.
	// Route kept alive because Kidnap.jsx, SecretSalute.jsx, ComposePost.jsx, and
	// Navbar.jsx still navigate here with ?questID=3&simple=1.
	{ path: "/choose-quest", title: "Choose Quest", component: ChooseQuest },
	{
		path: "/user-role-display",
		title: "User Role Display",
		component: EnhancedUserRoleDisplay,
	},
	{
		path: "/story-landing",
		title: "Story Landing",
		component: Starfield,
	},
	{
		path: "/partymanager",
		title: "Ringleader Dashboard",
		component: RingleaderDashboard,
	},
	{
		path: "/accept-invite/:partyId/:contestid?/:memberid?/:role?/:type?",
		title: "Accept Invite",
		component: AcceptInvite,
	},
	{
		path: "/accept-invite-test/:inviteID",
		title: "Accept Invite Test",
		component: AcceptInviteTest,
	},
	{
		path: "/judge-onboarding/:contestID/:gameMasterID",
		title: "Judge Onboarding",
		component: JudgeOnboarding,
	},
	{
		path: "/starsalute/view/:starID",
		title: "Star Receipt",
		component: StarReceipt,
	},
	{
		path: "/starsalute/thumbnail/:starID",
		title: "Star Salute Thumbnail",
		component: StarSaluteThumbnail,
	},
	{
		path: "/secretsalute/view/:cardID",
		title: "Secret Salute View",
		component: SecretSaluteView,
	},
	{
		path: "/takeaguess/:cardID",
		title: "Take a Guess",
		component: Guess,
	},
	{
		path: "/dashboard",
		title: "User Dashboard",
		component: UserDashboard,
		authRequired: true,
	},
	{
		path: "/start",
		title: "Start",
		component: Start,
	},
	{
		path: "/start-select",
		title: "Start Select",
		component: StartSelect,
	},
	{
		path: "/kidnap",
		title: "Kidnap",
		component: Kidnap,
	},
	{
		path: "/egypt-story",
		title: "Egypt Story",
		component: EgyptStory,
	},
	{
		path: "/egypt-story/pre-survey/:preSurvey",
		title: "Egypt Story",
		component: EgyptStory,
	},
	{
		path: "/egypt-story/:stage",
		title: "Egypt Story",
		component: EgyptStory,
	},
	{
		path: "/story-path-editor",
		title: "Story Path Editor",
		component: StoryPathEditorPage,
	},

	// {
	// 	path: "/transparent-video",
	// 	title: "Transparent Video Demo",
	// 	component: TransparentLoopingVideoExample,
	// },
	// {
	// 	path: "/transparent-video-white-mask",
	// 	title: "Transparent Video White Mask Demo",
	// 	component: TransparentLoopingVideoWhiteMaskExample,
	// },
	{
		path: "/testsprites",
		title: "Sprite Sheet Tester",
		component: SpriteSheetLoaderTester,
	},
	{
		path: "/beamkinanimations",
		title: "Beamkin Animations",
		component: SpriteSheetAnimationDemonstrator,
	},
	{
		path: "/animated-envelope",
		title: "Animated Envelope Demo",
		component: AnimatedEnvelopePage,
	},
	{
		path: "/letter-path-editor",
		title: "Letter Path Editor",
		component: LetterPathEditor,
	},
	{
		path: "/test-star-salute-still-image",
		title: "Star Salute Still Image Test",
		component: StarSaluteStillImageTest,
	},
	{
		path: "/starsalute",
		title: "Star Salutes",
		component: StarSalute,
	},
	{
		path: "/video-forward-tutorial",
		title: "Video Forward Tutorial",
		component: VideoForwardTutorial,
	},
	{
		path: "/test-glow-complete",
		title: "Test Glow Complete",
		component: TestGlowComplete,
	},
	// ===== MOCK ADVENTURES (Mockup Only - Safe to Delete) =====
	{
		path: "/adventures",
		title: "My Adventures",
		component: MyAdventures,
	},
	// {
	// 	path: "/adventures/create",
	// 	title: "Create Adventure",
	// 	component: AdventureCreate,
	// },
	// Must be before :id — Lifecorp role gate, then path (both use SSE).
	{
		path: "/adventures/adventure/adv-lifecorp/select-role",
		title: "Choose your role",
		component: RoleSelector,
	},
	{
		path: "/adventures/adventure/adv-lifecorp",
		title: "Lifecorp Adventure",
		component: RoleAdventure,
	},
	// {
	// 	path: "/adventures/adventure/:id",
	// 	title: "Adventure",
	// 	component: SoloAdventure,
	// },
	{
		path: "/test-qr",
		title: "QR Scanner Test",
		component: TestQRScanner,
		authRequired: true,
	},
	{
		path: "/qr-generator",
		title: "QR Code Generator",
		component: QRGeneratorPage,
		authRequired: true,
	},
	{
		path: "/icebreaker-survey",
		title: "Icebreaker Survey",
		component: IcebreakerSurveyPage,
	},
	{
		path: "/survey/:surveyId",
		title: "Survey",
		component: SurveyPage,
	},
	{
		path: "/survey/:surveyId/responses",
		title: "Survey Responses",
		component: SurveyResponsesPage,
	},
	{
		path: "/edit-member-milestones/:memberId",
		title: "Edit member milestones",
		component: EditMemberMilestones,
		authRequired: true,
	},
	{
		path: "/editSurvey/:surveyId",
		title: "Edit survey",
		component: EditSurveyPage,
	},
	{
		path: "/qrchallenge",
		title: "QR Challenge",
		component: QrChallengePage,
		authRequired: true,
	},
	{
		path: "/reward",
		title: "QR Challenge Reward",
		component: QrChallengeRewardPage,
	},
	{
		path: "/adventure-gm-controls",
		title: "Adventure GM Controls",
		component: AdventureGmControls,
		authRequired: true,
	},
	{
		path: "/gm-verify-step",
		title: "GM Verify Step",
		component: GmVerifyStep,
	},
	{
		path: "/lifecorp-team-progress",
		title: "Lifecorp Team Progress",
		component: AdventureTeamProgress,
		authRequired: true,
	},
	{
		path: "/adventure-reveal",
		title: "Submission Reveal",
		component: AdventureSubmissionReveal,
		authRequired: true,
	},
	{
		path: "/qr-puzzle-print",
		title: "QR Puzzle Print",
		component: QRPuzzlePrint,
		authRequired: true,
	},
	{
		path: "/video-subtitle-studio",
		title: "Video Subtitle Studio",
		component: VideoSubtitleStudio,
	},
];

const routes = [...coreRoutes];
export default routes;
